import _toLower from 'lodash/toLower'
import { AVAILIBLE_FILE_EXTENTIONS } from './const'

const getFileIcon = fileName => {
  const ext = fileName?.split('.')?.pop()
  const type = _toLower(ext)

  if (AVAILIBLE_FILE_EXTENTIONS[type]) {
    return require(`../components/images/fileType/${type}.png`)
  }  

  return require('../components/images/fileType/txt.png')
}

export default getFileIcon
